import { getRequestErrorMessage } from '../../apps/somar/src/utils/index'
import { defineStore } from 'pinia'
import { AxiosError } from 'axios'

export const useAlertStore = defineStore('alert', {
	state: () => ({
		message: {
			text: '',
			type: 'success',
		} as Message,
		show: false,
	}),

	actions: {
		setShow(show: boolean) {
			this.show = show
		},

		setMessage(message: Message) {
			this.message = message
			this.show = true
		},

		setError(error: string | AxiosError<{message: string}> | unknown) {
			if (typeof error === 'string' || typeof error === 'object')
				this.message = {
					type: 'error',
					text: typeof error === 'object'
						// @ts-ignore typescript cannot assign both types
						? getRequestErrorMessage(error)
						: error,
				}
			else {
				this.message = {
					type: 'error',
					text: 'An unkown error just happen',
				}
			}
			this.show = true
		},

		setSuccess(message: string | MessageOptions) {
			this.message = {
				type: 'success',
				...typeof message === 'string'
					? {
						text: message,
					}
					: message
			}
			this.show = true
		},

		setInfo(message: string | MessageOptions) {
			this.message = {
				type: 'info',
				...typeof message === 'string'
					? {
						text: message,
					}
					: message
			}
			this.show = true
		},
	},
})

export type Message = {
	text: string,
	type: 'success' | 'info' | 'warning' | 'error',
	timeout?: number
}

export type MessageOptions = Omit<Message, 'type'>
